import {ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import { GlobalService} from '../global.service';
import { Subject, Subscribable, Subscription } from 'rxjs';
import { baseUrls} from '../appConstant';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { regExpEscape } from '@ng-bootstrap/ng-bootstrap/util/util';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { ProductService } from '../services/product.service';
import { HttpService } from '../http.service';

declare var $: any;


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  public userDetails: any;
  public imgSrc: any = 'assets/images/profile-picture.png';
  public clickcheck = 0;
  public responseMessage = '';
  public showAlert = false;
  mode: string;
  public searchBar = new Subject<string>();
  public search:string='';
  public openSearch:boolean=false;
  public globalurl = baseUrls['global'];
  public emailtoken = '';
  private loginDetectorSubscription: Subscription;
  
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.globalServices.isBrowser) {
      if ($('.user-setting').hasClass('d-none') && $('.user-setting')?.length > 0){
      } 
      else if ($('.user-setting')?.length > 0) {
        if (!document.getElementById('user-settings-menu')?.contains(event.target) && this.clickcheck !== 0) {
          this.clickcheck = 0;
          $('#user-setting')?.addClass('d-none');
        } else{
          this.clickcheck = 1;
        }
      }
    }
  }
  constructor(public globalServices: GlobalService,
    public viewContainerRef: ViewContainerRef, public cfr: ComponentFactoryResolver,
    public httpService: HttpService,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private productService: ProductService ) {
    if(this.globalServices.isBrowser) {
      this.userDetails = localStorage.getItem('userDetails') ? JSON.parse(localStorage.getItem('userDetails')) : null;
      this.imgSrc = this.userDetails && this.userDetails['images'] && this.userDetails['images']['path'] ? baseUrls['images'] + this.userDetails['images']['path'] + this.userDetails['images']['name'] : 'assets/images/profile-picture.png';
    }
    this.loginDetectorSubscription = this.globalServices?.subjectTriggerForLoginDetectAtHeader.subscribe((responseChange: any) => {
      // if(responseChange){
        this.globalServices.isLoggedIn = responseChange;
      // }
      // console.log('ngOnInit_responseChange', responseChange, this.globalServices.imgSrc );
      this.cd?.detectChanges();
    })
   }
   
  ngOnInit(): void {
    if(this.globalServices.isBrowser){
      this.globalServices.headerviewcontainerhelper = this.viewContainerRef;
      this.globalServices.headercrf = this.cfr;
    if(localStorage.getItem('inviteToken')){
      this.opensignupmodal();
    }
    this.loadCountryData();
    this.loadShopCategoriesForMenu();
    this.loadWellnessStyleData();
    this.globalServices.isActivePlan =  localStorage.getItem("isActivePlan") ?  
                                          localStorage.getItem("isActivePlan") : 
                                          this.globalServices?.isActivePlan;  
    }
  }

  entersearch(){
    if(this.search !== ''){
      window.location.href = this.globalurl + 'travel/categories?globalSearch='+ this.search;
    }
  }

  openloginmodal(){
    // if (this.globalServices.isBrowser && document.getElementById("google-jssdk"))
    // document.getElementById("google-jssdk").parentNode.removeChild(document.getElementById("google-jssdk"));
    this.globalServices.viewcontainerhelper = this.viewContainerRef;
    this.globalServices.triggerlogin(this.viewContainerRef, this.cfr);

    // if(document.getElementById("newSignInPopUp")?.classList?.contains("active-login-popup")){
    //   document.getElementById("newSignInPopUp")?.classList?.remove("active-login-popup");
    // }
    // else{
    //   document.getElementById("newSignInPopUp")?.classList?.add("active-login-popup");
    // }
  }

  opensignupmodal() {
    // if (this.globalServices.isBrowser && document.getElementById("google-jssdk"))
    // document.getElementById("google-jssdk").parentNode.removeChild(document.getElementById("google-jssdk"));

    // this.globalServices.viewcontainerhelper = this.viewContainerRef;
    // this.globalServices.triggersignup(this.viewContainerRef, this.cfr);

  }
  

  public logOut() {
    if (this.globalServices.isBrowser) {
      this.userDetails = localStorage.getItem("userDetails") ? JSON.parse(localStorage.getItem("userDetails")) : null;

      let urlForgotPassword = "user/logout";
      this.mode = 'indeterminate';
      let data = {userId: this.userDetails ? this.userDetails['_id'] : null};
      this.httpService.postFormData(urlForgotPassword, data).subscribe(response => {
        if (response.success) {
          this.globalServices.isLoggedIn = false;
          if (this.globalServices.isBrowser) {
            let quantity = Number(localStorage.getItem('cartquantity'));
            // console.log(quantity);
            while (quantity > -1) {
              localStorage.removeItem('cartdata_' + quantity);
              quantity = quantity - 1;
            }
            //   for(let i = quantity; i >= 0; i++){
            //     localStorage.removeItem('cartdata_' + i);
            //   }

            this.globalServices.cartquantity = 0;
            localStorage.removeItem('cartquantity');
            localStorage.removeItem('userDetails');
            localStorage.removeItem('userToken');
            localStorage.removeItem("userEmail");
            localStorage.removeItem("userPass");
            localStorage.removeItem('planpayment');
            localStorage.removeItem('dataArray');
            // localStorage.removeItem('secondStepUserSubscription');
            // localStorage.removeItem('firstStepUserSubscription');
            localStorage.removeItem('moveToPlanPage');
            localStorage.removeItem('userSubscriptionPlan');
            localStorage.removeItem('isPlanActive');
            localStorage.removeItem('userSubscribeInfo');
            localStorage.removeItem('countryNameSelectedForShipping');
            localStorage.removeItem('userActivityLog');
            localStorage.removeItem('isSubscriptionPurchased');
            localStorage.removeItem('isActivePlan');
            window.location.href = '/';
          }
          // this.router.navigate(['/']);
        }
        localStorage.removeItem('planpayment');
        localStorage.removeItem('dataArray');
        localStorage.removeItem('userDetails');
        localStorage.removeItem('userToken');
        this.mode = 'indeterminate';
      });
    }
  }

  showprofilemenu($event, type: any){

    if (this.globalServices.isBrowser){
      $('#' + type).removeClass('d-none');
    }
  }

  sendemail() {
    if (this.globalServices.isBrowser) {
      let url = 'user/verify-email';
      let data = {email: localStorage.getItem('userEmail')};
      this.mode = 'indeterminate';
      this.httpService.postFormData(url, data).subscribe(response => {
        this.mode = 'determinate';
        if (response.success) {
          this.showAlert = true;
          this.responseMessage = 'Email verification link sent successfully!';
        } else {
          this.showAlert = true;
          this.responseMessage = response.message;
        }
        // console.log(response);
      });
    }
  }

  public triggerCloseEvent() {
    this.showAlert = false;
  }

  logoClick(){
    // if(this.globalServices.isLoggedIn){
    //   this.router.navigate(['/'])
    //   // location.href="/home"
    // }else{
    //   location.href = "/"
    // }
    location.href = "/"
  }

  ngOnDestroy(){
    this.loginDetectorSubscription?.unsubscribe();
  }

  openSectionForLogin(){
    // FOR pop up login new section
    if(document.getElementById("newSignInPopUp")?.classList?.contains("active-login-popup")){
      document.getElementById("newSignInPopUp")?.classList?.remove("active-login-popup");
    }
    else{
      document.getElementById("newSignInPopUp")?.classList?.add("active-login-popup");
    }
  }
  openSectionForLogout(){
    // FOR pop up logout new section
    if(document.getElementById("AfterNewSignInPopUp")?.classList?.contains("active-login-popup")){
      document.getElementById("AfterNewSignInPopUp")?.classList?.remove("active-login-popup");
    }
    else{
      document.getElementById("AfterNewSignInPopUp")?.classList?.add("active-login-popup");
    }
  }

  shopCategories;
  loadShopCategoriesForMenu(){
    this.productService.postCategoryOfProducts({start:0,length:15})?.subscribe((resOfCategories: any) => {
      // console.log('loadShopCategoriesForMenu_1', resOfCategories);
      if(resOfCategories?.data?.length > 0){
        this.shopCategories = resOfCategories?.data;
      }
    })
  }
  wellnessStyleData;
  loadWellnessStyleData() {
    let urlactivitiesData = 'home/category-subcategory';
    this.httpService.getData(urlactivitiesData).subscribe(response => {
      if(response){
        this.wellnessStyleData = response;
      }
    });
  }
  resCountryData
  loadCountryData() {
    let Url = "global/destinations";
    this.httpService.getData(Url).subscribe(response => {
      if(response){
        this.resCountryData = response;
      }
    });
  }
  navigationToggleButton(){
    // console.log('navigationToggleButton', document.body?.classList, document.getElementById("htmlTagId").classList);
    
    if(document.body.classList?.contains("overpage-hidden")){
      document.body.classList.remove("overpage-hidden");
      document.getElementById("htmlTagId").classList?.remove("overpage-hidden");
    }
    else{
      document.body.classList.add("overpage-hidden");
      document.getElementById("htmlTagId").classList?.add("overpage-hidden");
    }
    // document.html.classList.add("overpage-hidden");
  }
  addOrRemoveClass(indexPassed){
    // if(document?.getElementById('travelWellId')?.classList?.contains('active-menu')){
    //   document?.getElementById('travelWellId')?.classList?.remove('active-menu');
    // }
    // else{
    //   document?.getElementById('travelWellId')?.classList?.add('active-menu');
    // }
    if(this.globalServices?.isBrowser){
      let elements = document?.getElementsByClassName("menuListItem");
      for(let i= 0;i< elements?.length; i++){
        if(i == indexPassed){
          // console.log('addOrRemoveClass', i , indexPassed, elements[i]?.classList?.contains("active-menu"))
          if(elements[i]?.classList?.contains("active-menu")){
            elements[i]?.classList?.remove("active-menu");
          }
          else{
            elements[i]?.classList?.add("active-menu");
          }
        }
        else{
            elements[i]?.classList?.remove("active-menu");
        }
      }
    }
  }

  menuLavel3AddOrRemoveClassForDestination(eventPassed){
    eventPassed?.stopPropagation();
    // console.log('menuLavel3AddOrRemoveClassForDestination_1', document?.getElementById('menuLavel3AddOrRemoveClassIdForDestination')?.classList?.contains('active-lavel-3'));
    if(document?.getElementById('menuLavel3AddOrRemoveClassIdForDestination')?.classList?.contains('active-lavel-3')){
      document?.getElementById('menuLavel3AddOrRemoveClassIdForDestination')?.classList?.remove('active-lavel-3');
    }
    else{
      document?.getElementById('menuLavel3AddOrRemoveClassIdForDestination')?.classList?.add('active-lavel-3');
    } 
  }
  menuLavel3AddOrRemoveClassForWellnessStyle(eventPassed){
    eventPassed?.stopPropagation();
    if(document?.getElementById('menuLavel3AddOrRemoveClassIdForWellnessStyle')?.classList?.contains('active-lavel-3')){
      document?.getElementById('menuLavel3AddOrRemoveClassIdForWellnessStyle')?.classList?.remove('active-lavel-3');
    }
    else{
      document?.getElementById('menuLavel3AddOrRemoveClassIdForWellnessStyle')?.classList?.add('active-lavel-3');
    } 
  }
  menuLavel3AddOrRemoveClass(eventPassed){
    eventPassed?.stopPropagation();
    // this.navigationToggleButton();  
    if(document?.getElementById('menuLavel3AddOrRemoveClassId')?.classList?.contains('active-lavel-3')){
      document?.getElementById('menuLavel3AddOrRemoveClassId')?.classList?.remove('active-lavel-3');
    }
    else{
      document?.getElementById('menuLavel3AddOrRemoveClassId')?.classList?.add('active-lavel-3');
    } 
  }

  baseUrls = baseUrls;
  subCategoryOfShopClick(eventPassed){
    eventPassed?.stopPropagation();
    this.navigationToggleButton();
  }
  shopWellSectionClick(event){
    event?.stopPropagation();
    if(window.screen.availWidth > 1100){
      // window.open(this.baseUrls?.hostedUrl + "shopwell");
      location.href = this.baseUrls?.hostedUrl + "shopwell";
    }
    else{
    this.addOrRemoveClass(2); 
    }
  }
  navigateToProduct(object, type) {
    let queryParam: any = {};
    let link = '';
    if (type == 'country') {
      queryParam.country = object.slug
    } else if (type == 'programCat') {
      queryParam.programCategory = object.slug
      link = 'categories?programCategory=' + object.slug + '&isFromHeader=true';
    } else if (type == 'state') {
      queryParam.state = object.slug
    } else {
      queryParam.programSubCategory = object.slug
      link = this.baseUrls?.hostedUrl +'travel/'+ 'categories?programSubCategory=' + object.slug + '&isFromHeader=true';
    }
    queryParam['isFromHeader'] = true;
    return link;
    // categories?programSubCategory=spa-retreats&isFromHeader=true
    // this.router.navigate(['/categories'], {
    //   queryParams: JSON.parse(JSON.stringify(queryParam)),
    // });
  
  }
  goToTravelWellnessStyle(object, type){
    if(this.globalServices?.isBrowser){
    let queryParam: any = {};
    let link = '';
    if (type == 'programCat') {
      queryParam.programCategory = object.slug
      link = 'categories?programCategory=' + object.slug + '&isFromHeader=true';
      window.open(this.baseUrls?.hostedUrl + "travel/"+ link)
    }
  }
  }
  getlinkfromstate(object, region, country){
    if(this.globalServices?.isBrowser){
      return this.baseUrls?.hostedUrl + 'travel/destinations/' + region + '/' + country + '/' + object.slug;
    }
  }
  navigateFromCountries(object, region, slug) {
    if(this.globalServices?.isBrowser){
      window.open(this.baseUrls?.hostedUrl + 'travel/destinations/' + region + '/' + slug, "_blank");
    }
  }
  clickOnCountryInDestinationsInMobile(indexPassed){
    if(indexPassed == 0 || indexPassed > 0){
      const elements =  document.getElementsByClassName("DestinationCountrySubMenu");
      for(let i=0; i< elements?.length; i++){
        if(i == indexPassed){
          if(elements[i]?.classList?.contains("hideByDefaultOnMobile")){
            elements[i]?.classList?.remove("hideByDefaultOnMobile");
            elements[i]?.classList?.add("showOnMobile");
          }
        }
        else{
          elements[i]?.classList?.add("hideByDefaultOnMobile");
        }

      }
    }
  }
  travelWellSectionClick(event){
    event?.stopPropagation();
    if(window.screen.availWidth > 1100){
      // window.open(this.baseUrls?.hostedUrl + "travel");
      location.href = this.baseUrls?.hostedUrl + "travel";
    }
    else{
    this.addOrRemoveClass(1);
    }
  }
  moveToClasses(eventPassed){
    eventPassed?.stopPropagation();
    window.location.href = this.baseUrls?.hostedUrl + "livewell/classes";
    // window.open(this.baseUrls?.hostedUrl + "livewell/classes", '_blank');
  }
  moveToPrograms(eventPassed){
    eventPassed?.stopPropagation();
    // window.open(this.baseUrls?.hostedUrl + "livewell/programs", '_blank');
    window.location.href = this.baseUrls?.hostedUrl + "livewell/programs";
  }
  moveToOneToOne(eventPassed){
    eventPassed?.stopPropagation();
    // window.open(this.baseUrls?.hostedUrl + "livewell/personal-coaching", '_blank');
    window.location.href = this.baseUrls?.hostedUrl + "livewell/personal-coaching";
  }
  liveWellSectionClick(event){
    event?.stopPropagation();
    // console.log('liveWellSectionClick', window.screen.width, window.screen.width * window.devicePixelRatio);
    if(window.screen.availWidth > 1100){
      // window.open(this.baseUrls?.hostedUrl + "livewell");
      location.href = this.baseUrls?.hostedUrl + "livewell";

    }
    else{
    this.addOrRemoveClass(0); 
    }
  }
  subcategoryOfShopClicked(categoryInfo, subCategoryInfo){ 
    // console.log('subcategoryOfShopClicked', categoryInfo, subCategoryInfo);
    if(subCategoryInfo && categoryInfo){
      return this.baseUrls?.hostedUrl + "shopwell/category/"+ categoryInfo?.slug +";subcategory="+ subCategoryInfo?._id;
    }
  }
  searchInSectionSelectedValue = "all";
  searchInArea(eventPassed){
    // console.log('searchInArea', eventPassed?.target?.value);
    this.searchInSectionSelectedValue = eventPassed?.target?.value;
  }
  searchText;
  searchTextEnter(eventPassed){
    // console.log('searchTextEnter', eventPassed, eventPassed?.target?.value );
    if(eventPassed?.key == "Enter" && eventPassed?.keyCode == 13){
      this.searchNow(eventPassed?.target?.value);
    }
  }

  searchNow(searchText){  
    // console.log('searchNow', searchText);
    if(searchText){
      let areaForSearch = "all";
      let subSectionForSearch = "digital";
      if(this.searchInSectionSelectedValue == "all"){
        areaForSearch = "all";
        subSectionForSearch = "digital";
      }
      if(this.searchInSectionSelectedValue == "digital"){
        areaForSearch = "digital";
        subSectionForSearch = "digital";
      }
      if(this.searchInSectionSelectedValue == "travel"){
        areaForSearch = "travel";
        subSectionForSearch = "travel";
      }
      if(this.searchInSectionSelectedValue == "shop"){
        areaForSearch = "shop";
        subSectionForSearch = "shop";
      }
      window.location.href = this.baseUrls?.hostedUrl + `search;text=${searchText.trim()};area=${areaForSearch};sub=${subSectionForSearch}`
      // this.router.navigate(['/search', {text : searchText.trim(), area: areaForSearch, sub: subSectionForSearch }] )
    }
  } 
  goToUrl(urlLink){
    if(this.globalServices?.isBrowser && urlLink){
      window.open(urlLink);
    }
  }
  categoryOfShopClicked(categoryInfo){ 
    // console.log('categoryOfShopClicked', categoryInfo);
    if(categoryInfo){
      location.href = this.baseUrls?.hostedUrl + "shopwell/category/"+ categoryInfo?.slug;
    }
  }
  menuLavel3AddOrRemoveClassForShopwell(eventPassed){
    // console.log('menuLavel3AddOrRemoveClassForShopwell', document?.getElementById('menuLavel3AddOrRemoveClassIdForShopwell')?.classList)
    // eventPassed?.stopPropagation();
    if(document?.getElementById('menuLavel3AddOrRemoveClassIdForShopwell')?.classList?.contains('active-lavel-3')){
      document?.getElementById('menuLavel3AddOrRemoveClassIdForShopwell')?.classList?.remove('active-lavel-3');
      setTimeout(() => {
        this.addOrRemoveClass(2);
      }, 500)
    }
    else{
      this.addOrRemoveClass(2);
      // for shopwell in mobile only it is worked
      //  if(indexPassed == 2 ){
        setTimeout(() => {
          document?.getElementById('menuLavel3AddOrRemoveClassIdForShopwell')?.classList?.add('active-lavel-3');
            }, 500);
          // }
    } 
  }
  showDestinations = false;
  showTravel = true;
    addActiveClasstoThisNavLink(eventPassed, indexPassed){
    eventPassed?.stopPropagation();
    if(this.globalServices?.isBrowser){
      let elements = document?.getElementsByClassName("TravelSubMenu");
      for(let i= 0;i< elements?.length; i++){
        if(i == indexPassed){
          if(elements[i]?.classList?.contains("active")){
            // elements[i]?.classList?.remove("active");
          }
          else{
            elements[i]?.classList?.add("active");
          }
        }
        else{
            elements[i]?.classList?.remove("active");
        }
      }
      if(indexPassed == 0){
        this.showDestinations = false;
        this.showTravel = true;
      }
      if(indexPassed == 1){
        this.showDestinations = true;
        this.showTravel = false;
      }
      if(indexPassed == 2){
        this.showDestinations = false;
        this.showTravel = false;
      }
    }

  }

moveToJoinTravelClub(){
    if(this.globalServices?.isBrowser){
      window.location.href  = this.baseUrls?.hostedUrl + "travel/club";
    } 
  }
  menuLavel3AddOrRemoveClassForTravelClub(eventPassed){
    eventPassed?.stopPropagation();
    // console.log('menuLavel3AddOrRemoveClassForTravelClub', document?.getElementById('menuLavel3AddOrRemoveClassIdForDestination')?.classList?.contains('active-lavel-3'));
    if(window.screen.availWidth < 756){
      this.moveToJoinTravelClub();
      return;
    }
    if(document?.getElementById('menuLavel3AddOrRemoveClassIdForTravelClub')?.classList?.contains('active-lavel-3')){
      document?.getElementById('menuLavel3AddOrRemoveClassIdForTravelClub')?.classList?.remove('active-lavel-3');
    }
    else{
      document?.getElementById('menuLavel3AddOrRemoveClassIdForTravelClub')?.classList?.add('active-lavel-3');
    } 
  }
  moveToMembershipPage(){
    this.globalServices?.moveToMembershipPage();
  }
}


